import { Container } from 'geniebook-ui/dist';
import './AccountOverlay.css';
import React, { useEffect } from 'react';
import AccountMenu from './AccountMenu';
import CaretDown from '@assets/icons/caret-down';
import RightFromBracket from '@assets/icons/right-from-bracket';
import { NumberToFormattedString } from '@utils/helpers/formatNumber';
import AccountGirl from '@assets/illustration/AccountGirl';
import AccountMoon from '@assets/illustration/AccountMoon';
import { CDN_URL } from '@utils/constants/url.constants';
import { useVerifyBubbleStoreLogin } from '@hooks/user.hook';
import { Button } from 'geniebook-ui/dist';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons/faCartShopping';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import {
  AccountMenuBubbleContainer,
  DetailItem,
} from './styles/AccountOverlay.style';
import {
  AccountMenuItem,
  AccountMenuItemSpan,
} from './styles/AccountMenu.style';
import { useStore, useSetAtom, useAtomValue } from 'jotai';
import { haveBottomNavbar } from '@atom/navbarAtom';
import BubbleDropdownIconTablet from '@assets/icons/bubble-dropdown-icon-tablet';
import { showUnlockTrialPopUpAtom } from '@atom/popUpAtom';
import globalStore from '@store/globalStore';
import { haveSubjectForTrialAtom } from '@atom/globalQueryAtom';
import { goToHome } from '@components/navigation/NavBar';
import { useNavigate, useLocation } from 'react-router-dom';

export interface AccountOverlayProps {
  bubbleEarned: number;
  bubbleSpent: number;
  isShowBubbleDropdown: boolean;
  showAccountDropdown: boolean;
  setIsShowBubbleDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAccountDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  logoutCallback: () => void;
  isJC?: boolean;
}

const AccountOverlay = ({
  bubbleEarned,
  bubbleSpent,
  isShowBubbleDropdown,
  showAccountDropdown,
  setIsShowBubbleDropdown,
  setShowAccountDropdown,
  logoutCallback,
  isJC = false,
}: AccountOverlayProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryBubbleStoreLogin = useVerifyBubbleStoreLogin();
  const store = useStore();
  const setUnlockTrialPopUp = useSetAtom(showUnlockTrialPopUpAtom, {
    store: globalStore,
  });
  const haveSubjectForTrial = useAtomValue(haveSubjectForTrialAtom);

  useEffect(() => {
    if (showAccountDropdown) {
      store.set(haveBottomNavbar, true);
    }
  }, [showAccountDropdown]);

  const handleButtonClick = async () => {
    await queryBubbleStoreLogin.mutateAsync();
  };

  const toHome = () => {
    goToHome(location, navigate);
  };

  return (
    <div
      id="account-menu-small-screen"
      className="account-menu-overlay lg:hidden fixed top-0 left-0 right-0 bottom-0 max-lg:block max-lg:pb-[56px] max-md:pb-[84px]"
    >
      <div className="account-menu-header sticky w-full left-0 top-0 z-100">
        <header className="max-md:!py-1 py-4 lg:bg-neutral-whiteboard bg-[#16133E] max-md:h-10">
          <Container className="testing flex text-left items-center max-md:h-full max-lg:!px-4 py-[1px]">
            <button onClick={toHome} className="flex items-center">
              <img
                className="h-6 max-md:!h-4 cursor-pointer"
                src={`${CDN_URL}assets/icons/navigation/logo-simplified.svg`}
                alt={'geniebook'}
              />
              <p className="max-lg:pl-6 max-md:pl-2 max-md:text-md md:text-lg font-black text-neutral-whiteboard cursor-pointer">
                Account
              </p>
            </button>
          </Container>
        </header>
      </div>
      <Container
        className={`${
          isJC ? '' : 'account-menu-body'
        } max-lg:md:!pl-12 max-lg:md:!pr-16 max-md:!pl-0 max-md:!pr-4 overflow-hidden bg-left-bottom h-full pt-6 relative bg-no-repeat bg-cover bg-fixed bg-primary-navyblue-dark`}
      >
        <div className={'h-full overflow-auto relative z-[2]'}>
          <AccountMenuBubbleContainer
            className={`account-menu-bubble-container ${
              isShowBubbleDropdown === true ? 'open !pb-0' : ''
            } !w-[calc(100%-16px)] ml-4`}
            onClick={(event: React.FormEvent) => {
              event.stopPropagation();
              setIsShowBubbleDropdown(!isShowBubbleDropdown);
            }}
          >
            <img
              src={`${CDN_URL}assets/icons/general/bubble.svg`}
              alt={'bubble'}
              className="max-h-5 max-w-[20px] mr-1"
            />
            <span className="text-primary-skyblue text-md leading-4 font-black">
              {NumberToFormattedString(bubbleEarned - bubbleSpent)}
            </span>
            <CaretDown />
            <div
              className={
                'bubble-details w-full h-0 overflow-hidden ' +
                (isShowBubbleDropdown === true ? 'open' : '')
              }
            >
              <DetailItem className="detail-item pt-3">
                <p>Earned</p>
                <span>{NumberToFormattedString(bubbleEarned)}</span>
              </DetailItem>
              <DetailItem className="detail-item">
                <p>Spent</p>
                <span>
                  {bubbleSpent == 0
                    ? '0'
                    : '-' + NumberToFormattedString(bubbleSpent)}
                </span>
              </DetailItem>
              <span
                className={
                  'link-to-bubble-store text-primary-apricot font-bold underline mt-6 mb-4 text-md w-full text-center flex justify-center items-center cursor-pointer'
                }
                onClick={() => handleButtonClick()}
              >
                <Button
                  className={
                    'text-white !font-black !text-sm px-4 !h-9 !max-w-full !w-full'
                  }
                  onClick={handleButtonClick}
                >
                  <FontAwesomeIcon
                    icon={faCartShopping}
                    className={'text-white w-[18px] h-4'}
                  />
                  &nbsp; Visit Bubble Store
                </Button>
              </span>
              {/* change url bg image later */}
              {haveSubjectForTrial && (
                <div
                  className={
                    'relative inherit-w pt-[16px] bg-[#D4F2FF] bg-cover bg-no-repeat -mx-6 px-6 pb-6 overflow-hidden break-all rounded-b-2xl'
                  }
                >
                  <div className="absolute right-0 top-0 h-[150px] w-[122px]">
                    <BubbleDropdownIconTablet className="h-[150px] w-[122px] fill-[#D4F2FF]" />
                  </div>
                  <p
                    className={
                      'relative text-sm font-bold leading-4 mb-3.5 text-primary-navyblue'
                    }
                  >
                    Need extra Bubbles?
                  </p>
                  <div
                    className={
                      'relative flex text-sm leading-4 text-neutral-pencil mb-4 break-words'
                    }
                  >
                    Purchase an additional subject plan to enjoy more rewards.
                  </div>
                  <div>
                    <Button
                      variant={'primary-azure'}
                      className={
                        'text-white !font-black !text-sm px-4 !h-9 !max-w-full !w-full'
                      }
                      onClick={() => setUnlockTrialPopUp(true)}
                    >
                      <FontAwesomeIcon
                        icon={faLock}
                        className={'text-white w-[18px] h-4'}
                      />
                      &nbsp; Unlock
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </AccountMenuBubbleContainer>

          <AccountMenu
            setShowAccountDropdown={setShowAccountDropdown}
            showAccountDropdown={showAccountDropdown}
            isJC={isJC}
            className="[&>.account-menu-group>.account-menu-item-container>a>div.account-menu-item]:!ml-0 [&>.account-menu-group>p]:!ml-4"
          />

          <AccountMenuItem
            className="account-menu-item mt-6 !ml-0"
            onClick={logoutCallback}
          >
            <p className="!text-alert-error">
              <RightFromBracket />
              <AccountMenuItemSpan>Logout</AccountMenuItemSpan>
            </p>
          </AccountMenuItem>
          <div className="h-[72px]"></div>
        </div>
        {!isJC && (
          <span className="pointer-events-none z-[1]">
            <AccountGirl className="w-[250px] h-[250px] absolute right-0 top-[20vh]" />
            <AccountMoon className="absolute right-[-220px] top-[50vh]" />
          </span>
        )}
      </Container>
    </div>
  );
};

export default AccountOverlay;
